import React from 'react';
import PropTypes from 'prop-types';

import Media from 'components/Media';
import Icon from 'components/Icon';
import OnPageEditing from 'components/OnPageEditing';

import cn from 'classnames';
import css from './BusinessAreaListBlock.module.scss';

class BusinessAreaListBlock extends React.Component {
    static propTypes = {
        heading: PropTypes.string.isRequired,
        links: PropTypes.arrayOf(PropTypes.shape({
            href: PropTypes.string,
            target: PropTypes.string,
            icon: PropTypes.string,
            title: PropTypes.string,
            backgroundImage: Media.propTypes.image,
        })).isRequired,
        loopDuration: PropTypes.number,
        fadeDuration: PropTypes.number,
    };
    
    static defaultProps = {
        loopDuration: 5000,
        fadeDuration: 500
    }

    state = {
        topSrc: false,
        bottomSrc: false,
        bottomOpacity: 0
    };

    componentDidMount = () => {
        this.setBackgroundImage(0);
        this.startLoop();
    }

    componentWillUnmount = () => {
        clearTimeout(this.timeout);
        clearInterval(this.interval);
    }

    startLoop = () => {
        if(this.props.links.length > 1)
            this.interval = setInterval(this.updateBackgroundImage, this.props.loopDuration);
    }

    updateBackgroundImage = () => {
        this.setBackgroundImage((this.state.topSrc+1)%this.props.links.length);
    }

    setBackgroundImage = (target) => {
        if(target >= 0 && target < this.props.links.length)
            this.crossFade(target);
    }

    crossFade(newIndex) {
        const oldIndex = this.state.topSrc;
        if (newIndex !== oldIndex) {
            // cancel out animation if any is running
            this.setState({ bottomSrc: false, topSrc: false }, () =>
                this.setState(
                    { 
                        
                        bottomSrc: oldIndex, 
                        topSrc: newIndex, 
                        bottomOpacity: 0.99 
                    },
                    () => {
                        clearTimeout(this.fadeTimeout);
                        this.fadeTimeout = setTimeout(
                            () => this.setState({ bottomOpacity: 0 }),
                            20
                        );
                    }
                )
            );
        }
    }

    _onMouseOver = (e) => {
        const target = parseInt(e.currentTarget.dataset.index, 10);
        clearInterval(this.interval);
        clearTimeout(this.timeout);
        this.setBackgroundImage(target);
    }

    _onMouseOut = () => {
        this.timeout = setTimeout(()=>{
            this.startLoop();
        }, 5000);
    }

    render() {
        const {
            heading,
            links,
            fadeDuration,
        } = this.props;

        const {
            topSrc,
            bottomSrc,
            bottomOpacity
        } = this.state;

        const classNames = cn(css.block, css.bg);

        return (
            <div className={classNames}>
                {/* BE: Mobile image recommended size is 768x1200px */}
                {topSrc !== false && (
                    <Media
                        image={this.props.links[topSrc].backgroundImage}
                        imageMobile={this.props.links[topSrc].backgroundImageMobile ? this.props.links[topSrc].backgroundImageMobile : this.props.links[topSrc].backgroundImage}
                        alt={heading}
                        onScreen={true} // fixed issue with onScreen being reset every time the component is re-rendered
                    />
                )}
                {bottomSrc !== false && (
                    <Media
                        image={this.props.links[bottomSrc].backgroundImage}
                        imageMobile={this.props.links[bottomSrc].backgroundImageMobile ? this.props.links[bottomSrc].backgroundImageMobile : this.props.links[bottomSrc].backgroundImage}
                        alt={heading}
                        onScreen={true} // fixed issue with onScreen being reset every time the component is re-rendered
                        style={{
                            ...{
                                opacity: bottomOpacity,
                                transition: `opacity ${fadeDuration / 1000}s ease`
                            }
                        }}
                    />
                )}
                <div className={css.content}>
                    <OnPageEditing property="Heading">
                        {heading && <h2 className={css.heading}>{heading}</h2>}
                    </OnPageEditing>
                    <OnPageEditing property="BusinessAreas">
                        {links && (
                            <ul className={css.links}>
                                {links.map((link, index) => (
                                    <li key={index} onMouseOver={this._onMouseOver} onMouseOut={this._onMouseOut} data-index={index}>
                                        <a className={cn(css.link, {
                                            [css.active]: index === topSrc
                                        })} href={link.href}>
                                            {link.icon && <Icon icon={link.icon} />}
                                            <span>{link.title}</span>
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </OnPageEditing>
                </div>
            </div>
        );
    }
}

export default BusinessAreaListBlock;


// WEBPACK FOOTER //
// ./src/components/BusinessAreaListBlock/BusinessAreaListBlock.jsx